const template = `
<div class="animation-modal animation-modal-hidden">
  <div class="animation-modal-content">
    <div class="animation-modal-content-inner">
      <div class="animation-modal-content-inner-letterbox">
        <div class="animation-modal-content-inner-video-wrapper"></div>
      </div>
    </div>
  </div>
  <div class="animation-modal-header">
    <div class="animation-modal-header-section-left">
      <button id="close" type="button">
        <span class="animation-modal-button-label">Close</span>
      </button>
    </div>
    <div class="animation-modal-header-section-right">
    </div>
  </div>
</div>
`.trim();

export default template;
